import { render, staticRenderFns } from "./ComprobantesPago.vue?vue&type=template&id=65311971"
import script from "./ComprobantesPago.vue?vue&type=script&lang=js"
export * from "./ComprobantesPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports